import { render, staticRenderFns } from "./AddLang.vue?vue&type=template&id=4ef8c283"
import script from "./AddLang.vue?vue&type=script&lang=js"
export * from "./AddLang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports